import { Action, Alert, TextAreaInput, TextInput } from 'corso-admin-ui';
import { EuCountryCodes, Pegasus } from 'corso-types';
import { useEffect } from 'react';
import { Controller } from 'react-hook-form';
import { useAutomationFormContext } from '~/features/settings/automations/hooks/useAutomationForm';

const requiredConditions = [
  {
    fact: Pegasus.Fact.orderCountry,
    operator: Pegasus.Operator.in,
    value: [...EuCountryCodes],
  },
] as const satisfies Pegasus.Expression[];

export default function EventRightToWithdraw() {
  const { control, watch, setValue } = useAutomationFormContext();

  const currentConditions = watch('conditions');

  useEffect(() => {
    const hasRequiredConditions = requiredConditions.every((rq) =>
      currentConditions.find(
        (c) =>
          c.fact === rq.fact &&
          c.operator === rq.operator &&
          Array.isArray(c.value) &&
          rq.value.every((v) => c.value.includes(v)),
      ),
    );

    if (hasRequiredConditions) return;

    setValue('conditions', requiredConditions);
  }, [currentConditions, setValue]);

  return (
    <>
      <Alert variant="warning" heading="EU Right to Withdraw">
        To learn more about how Corso handles the Right to Withdraw in
        compliance with EU regulations, please see our{' '}
        <Action
          to="https://help.corso.com/returns-exchange/right-to-withdraw"
          target="_blank"
          variant="link"
          rel="noreferrer"
        >
          help article.
        </Action>
      </Alert>

      <Controller
        control={control}
        name="event.params.rightToWithdrawTitle"
        render={({ field, fieldState }) => (
          <TextInput
            id="right-to-withdraw-title"
            label="Title"
            required
            {...field}
            error={fieldState.error?.message}
          />
        )}
      />
      <Controller
        control={control}
        name="event.params.rightToWithdrawDescription"
        render={({ field, fieldState }) => (
          <TextAreaInput
            id="right-to-withdraw-description"
            label="Description"
            details="The description explaining the customers rights."
            required
            {...field}
            error={fieldState.error?.message}
          />
        )}
      />
    </>
  );
}
